<template>
  <SvoiIcon :icon="icon" :size="size" />
</template>

<script lang="ts" setup>
import { SvoiIcon } from '@svoi-ui/components/icon'

defineProps<{
  icon: string
  size?: string
}>()
</script>
